import React from "react";
import GoogleMapReact from "google-map-react";
import MapMarker from "./map-marker.jsx";
import { googleApiKey } from '../../config.json';

const GoogleMap = props => {

    const getMapOptions = maps => {
        return {
            disableDefaultUI: false,
            mapTypeControl: true,
            zoomControlOptions: {
                position: maps.ControlPosition.RIGHT_CENTER,
                style: maps.ZoomControlStyle.SMALL
            },
            mapTypeControlOptions: {
                position: maps.ControlPosition.TOP_LEFT
            }
        };
    };
    let zoom = 5;
    let center;

    center = {
        lat: 43.75885,
        lng: -87.73145
    };

    if (props.userLat !== 0.0) {
        center = {
            lat: props.userLat,
            lng: props.userLng
        };
    }

    if (props.userLat === 0.0 && !props.firstLoad) {
        center = {
            lat: props.prevLat,
            lng: props.prevLng
        };
        if (props.prevLat === 0.0) {
            center = {
                lat: 43.75885,
                lng: -87.73145
            };
            zoom = 5;
        }
    }

    let count = 1;
    let distCount = 1;
    const emptyMarkers = [];

    const markers = props.markers.map((item) => {
        const dLat = parseFloat(item.latitude);
        const dLng = parseFloat(item.longitude);
        if (dLat !== 0 || dLng !== 0) {
            if (count === 1) {
                center.lat = dLat;
                center.lng = dLng;
            }
            return (
                <MapMarker
                    lat={dLat}
                    lng={dLng}
                    text={count++}
                    address={item.address}
                    city={item.city}
                    state={item.state}
                    zipcode={item.postalCode}
                    name={item.accountName}
                    onChange={props.onChange}
                    target={props.eventTarget}
                    class={props.markerClass}
                    dist={false}
                />
            );
        } else {
            center.lat = props.userLat;
            center.lng = props.userLng;
            return emptyMarkers;
        }
    });

    const distPins = props.distPins.map((item) => {
        const dLat = parseFloat(item.latitude);
        const dLng = parseFloat(item.longitude);
        if (dLat !== 0 || dLng !== 0) {
            if (count === 1) {
                center.lat = dLat;
                center.lng = dLng;
            }
            return (
                <MapMarker
                    lat={dLat}
                    lng={dLng}
                    text={distCount++}
                    address={item.address}
                    city={item.city}
                    state={item.state}
                    zipcode={item.postalCode}
                    name={item.accountName}
                    onChange={props.onChange}
                    target={props.eventTarget}
                    class={props.markerClass}
                    dist={true}
                />
            );
        } else {
            center.lat = props.userLat;
            center.lng = props.userLng;
            return emptyMarkers;
        }
    });

    if (!props.firstLoad) {
        switch (props.distance) {
            case "15":
                zoom = 11;
                break;
            case "25":
                zoom = 10;
                break;
            case "50":
                zoom = 9;
                break;
            case "100":
                zoom = 8;
                break;
            default:
                zoom = 5;
                break;
        }
    }

    if (!markers.length && !distPins.length) {
        center = {
            lat: 43.75885,
            lng: -87.73145
        };
        zoom = 5;
    }

    return (
        <div className="google-map">
            <GoogleMapReact
                bootstrapURLKeys={{ key: googleApiKey }}
                center={center}
                zoom={zoom}
                defaultZoom={zoom}
                options={getMapOptions}
                onChange={props._onChange}
            >
                {markers}
                {distPins}
            </GoogleMapReact>
        </div>
    );
};

export default GoogleMap;
